/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Security_Access_DescInputs */

const es_privacy_policy_security_access_desc = /** @type {(inputs: Privacy_Policy_Security_Access_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RBAC y principio de privilegio minimo para todo el acceso personal y de sistema. 2FA requerido para acceso administrativo.`)
};

const en_privacy_policy_security_access_desc = /** @type {(inputs: Privacy_Policy_Security_Access_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RBAC and least-privilege principle for all personal and system access. 2FA required for administrative access.`)
};

/**
* | output |
* | --- |
* | "RBAC and least-privilege principle for all personal and system access. 2FA required for administrative access." |
*
* @param {Privacy_Policy_Security_Access_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_security_access_desc = /** @type {((inputs?: Privacy_Policy_Security_Access_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Security_Access_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_security_access_desc(inputs)
	return en_privacy_policy_security_access_desc(inputs)
});
export { privacy_policy_security_access_desc as "privacy_policy.security.access_desc" }